import CommissionDistributions from "./commission-distributions";

export const Offcanvas = { CommissionDistributions };
